/**
 * Геометрия контура зоны (FE-Z02, FE-Z04). Точка — [x, y] в пикселях
 * original-кадра. Замкнутый контур: последняя точка равна первой.
 */
export const MIN_POLYGON_POINTS = 3;

const samePoint = (a, b) => Array.isArray(a) && Array.isArray(b) && a[0] === b[0] && a[1] === b[1];

export const isPolygonClosed = (points) =>
  Array.isArray(points) && points.length >= MIN_POLYGON_POINTS + 1
  && samePoint(points[0], points[points.length - 1]);

/** Уникальные вершины: замыкающая копия первой точки и дубли не считаются. */
export const countUniquePoints = (points) => {
  if (!Array.isArray(points)) return 0;
  const seen = new Set(points.map((p) => `${p[0]}:${p[1]}`));
  return seen.size;
};

/** Убирает повторяющиеся замыкающие копии первой вершины, оставляя одну. */
export const dedupeClosingPoints = (points) => {
  if (!Array.isArray(points) || points.length === 0) return [];
  const result = [...points];
  while (result.length > 1 && samePoint(result[result.length - 1], result[0])
    && samePoint(result[result.length - 2], result[0])) {
    result.pop();
  }
  return result;
};

/** Идемпотентно: уже закрытый контур возвращается как есть. */
export const closePolygon = (points) => {
  const cleaned = dedupeClosingPoints(points);
  if (cleaned.length < MIN_POLYGON_POINTS) return cleaned;
  if (isPolygonClosed(cleaned)) return cleaned;
  return [...cleaned, [cleaned[0][0], cleaned[0][1]]];
};

/**
 * Отрицательная координата — отсчёт от конца кадра (как отрицательный индекс
 * numpy): backend хранит зону «весь кадр» sentinel'ом
 * [[0,0],[0,-1],[-1,-1],[-1,0],[0,0]] (default monitoring_zone). Буквальная
 * отрисовка такого контура — невидимый пиксель в левом верхнем углу, поэтому
 * перед показом/редактированием точки разворачиваются по natural-размеру
 * кадра. Без размера (кадр ещё не загружен) точки возвращаются как есть.
 */
export const resolveFramePoints = (points, width, height) => {
  if (!Array.isArray(points)) return [];
  if (!(width > 0) || !(height > 0)) return points;
  return points.map(([x, y]) => [x < 0 ? width + x : x, y < 0 ? height + y : y]);
};
